module.exports = __webpack_public_path__ + "media/scorpion.b99d9dae.mp3";